import { flow, getParent, getRoot, types } from 'mobx-state-tree';

const ItemSpecific = types
  .model('ItemSpecific', {
    discoveryItemId: types.maybe(types.number),
    id: types.maybe(types.number),
    key: types.maybe(types.string),
    name: types.maybe(types.string),
    value: types.maybe(types.string),
    isEditable: types.maybe(types.boolean),
    isMandatory: types.maybe(types.boolean),
    // hovering: false,
  })
  .actions(self => ({
    setNewValue: value => {
      self.value = value;
    },
    // setHover: val => {
    //   self.hovering = val;
    // },
    removeSelf: flow(function*() {
      yield getRoot(self)
        .uiStore.discoveryStore.deleteItemSpecific(self.id)
        .then(() => {
          getParent(self, 2).removeSpecific(self.id);
        });
    }),
  }));

export default ItemSpecific;
